import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  title: string
  children: ReactNode
  minHeight?: number | string
}

export const SectionCard = ({ title, children, minHeight }: Props) => {
  return (
    <Stack
      minHeight={minHeight ?? 400}
      sx={{ backgroundColor: '#FFF', boxShadow: 2, borderRadius: '8px' }}
    >
      <Stack
        alignItems="center"
        sx={{
          backgroundColor: 'primary.main',
          color: '#fff',
          padding: 3,
          borderTopRightRadius: '8px',
          borderTopLeftRadius: '8px',
        }}
      >
        <Typography variant="caption" fontWeight="bold">
          {title}
        </Typography>
      </Stack>
      <Stack sx={{ py: 3, px: 2, height: '100%', flexGrow: 1 }}>{children}</Stack>
    </Stack>
  )
}
